/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import * as image from "../../common/image";
import * as selection from "./selection";
import * as notification_service from "./notification_service";
export { image, selection, notification_service };
export var SearchKey = {
  SEARCH_KEY_UNSPECIFIED: 0,
  SEARCH_BY_PRODUCT_ID: 1,
  SEARCH_BY_PRODUCT_NAME: 2,
  SEARCH_BY_PLAN_ID: 3,
  SEARCH_BY_CREATOR_NAME: 4,
  SEARCH_BY_SHOP_NAME: 5,
  SEARCH_BY_PLAN_NAME: 6,
  SEARCH_BY_CREATOR_ID: 7,
  SEARCH_BY_CREATOR_OEC_ID: 8,
  SEARCH_BY_SHOP_ID: 9,
  SEARCH_BY_CATEGORY_ID: 10
};
export var PlanType = {
  PLAN_TYPE_UNSPECIFIED: 0,
  PUBLIC: 1,
  TARGET: 2,
  SHOP_PLAN: 3
};
export var PlanTargetType = {
  PLAN_TARGET_TYPE_UNSPECIFIED: 0,
  PRODUCT: 1,
  CATEGORY: 2,
  SHOP: 3,
  PLATFORM: 4
};
export var PlanStatus = {
  PLAN_STATUS_UNSPECIFIED: 0,
  RUNNING: 1,
  END: 2,
  ENDING: 3,
  UNAVAILABLE: 4,
  INVALID: 5,
  EXPIRED: 6,
  DELETED: 7,
  CREATED: 8,
  PROHIBITED: 9,
  WITHDRAW: 10,
  DELETING: 11,
  EXPIRING: 12
};
export var SubPlanStatus = {
  META_PLAN_STATUS_UNSPECIFIED: 0,
  NORMAL: 1,
  SELLER_REMOVED: 2,
  PLATFORM_WITHDRAW: 3,
  SELLER_REMOVING: 4
};
export var RequestStatus = {
  APPROVAL_STATUS_UNSPECIFIED: 0,
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
  DELETE_APPROVAL: 4,
  WITHDRAWN: 5,
  REQUEST_EXPIRED: 6,
  REJECTING: 7
};
export var ShowcaseBindStatus = {
  SHOWCASE_BIND_STATUS_UNSPECIFIED: 0,
  SHOWCASE_ADDED: 1,
  SHOWCASE_PENDING: 2,
  CREATOR_RELATION_REMOVED: 3,
  CREATOR_RELATION_REMOVING: 4
};
export var RelationOperation = {
  RELATION_OPERATION_UNSPECIFIED: 0,
  RELATION_REMOVE: 1
};
export var ApprovalType = {
  APPROVAL_TYPE_UNSPECIFIED: 0,
  SELLER: 1,
  CREATOR: 2,
  NONE: 3
};
export var ProductStatus = {
  PRODUCT_STATUS_UNSPECIFIED: 0,
  LIVE: 1,
  QC_FAILED: 2,
  OUT_OF_STOCK: 3,
  FREEZE: 4,
  SELLER_DE_ACTIVE: 5,
  PLATFORM_DE_ACTIVE: 6,
  QC_PENDING: 7,
  DRAFT: 8,
  DELETE: 9,
  IN_PLAN: 10,
  WITHDRAW_BY_PLATFORM: 11,
  LIMIT_BY_PLATFORM: 12
};
export var AddShowCaseStatus = {
  ALL_IN_SHOW_CASE: 1,
  PARTIAL_IN_SHOW_CASE: 2,
  NONE_IN_SHOW_CASE: 3
};
export var PlanAction = {
  PLAN_ACTION_UNSPECIFIED: 0,
  EDIT: 1,
  STOP: 2,
  DELETE_PLAN: 3,
  RECOVER: 4
};
export var ProductSelectionStatus = {
  PRODUCT_SELECTION_STATUS_UNSPECIFIED: 0,
  NO_PRODUCT: 1,
  ALL_IN_PLAN: 2,
  NO_ALL_IN_PLAN: 3
};
export var PlanCommissionType = {
  ALL_PLAN_COMMISSION: 0,
  PUBLIC_PLAN_COMMISSION: 1,
  TARGET_PLAN_COMMISSION: 2,
  SHOP_PLAN_COMMISSION: 3
};
export var PlanSource = {
  DEFAULT: 0,
  CREATOR_MARKETPLACE: 1
};
export var GROIFreeSampleIneligibleCode = {
  UNAUTHORIZED_INELIGIBLE: 0,
  IMAGES_INELIGIBLE: 1,
  DESCRIPTION_INELIGIBLE: 2,
  SELLER_TIER_INELIGIBLE: 3,
  DELV_SPEED_INELIGIBLE: 4,
  INVENTORY_DAYS_OF_COVER_INELIGIBLE: 5,
  COMMISSION_RATE_INELIGIBLE: 6,
  OPEN_PLAN_CREATOR_APPROVE_INELIGIBLE: 7,
  OPEN_PLAN_INELIGIBLE: 8,
  PRODUCT_STATUS_INELIGIBLE: 9,
  GNE_LATE_DISPATCH_RATE_INELIGIBLE: 100,
  GNE_CANCELLATION_RATE_INELIGIBLE: 101,
  GNE_NEGATIVE_REVIEW_RATE_INELIGIBLE: 102
};
export var FreeSampleRuleThresholdType = {
  FOLLOWER_COUNT: 1,
  GMV: 2,
  CONTENT_COUNT: 3,
  AVG_EC_VIDEO_VIEWS_30_DAY: 4,
  MAIN_CATEGORY_IDS: 5,
  FULFILLMENT_RANK: 6
};
export var FreeSampleRuleStatus = {
  FREE_SAMPLE_ENABLED: 1,
  PLAN_EXCEPTION: 2,
  FREE_SAMPLE_NO_LEFT_COUNT: 3,
  FREE_SAMPLE_EXPIRED: 4,
  FREE_SAMPLE_NOT_CREATED: 5,
  FREE_SAMPLE_NOT_STARTED: 6
};
export var AffiliateCreatorType = {
  AFFILIATE_CREATOR_TYPE_UNSPECIFIED: 0,
  AFFILIATE_CREATOR_TYPE_NORMAL: 1,
  AFFILIATE_CREATOR_TYPE_SELF_SOLD: 2
};
export var SortField = {
  SORT_FIELD_UNSPECIFIED: 0,
  SORT_FIELD_PRICE_RANGE: 1,
  SORT_FIELD_COMMISSION_RATE: 2,
  SORT_FIELD_SALES: 3,
  SORT_FIELD_ESTIMATED_COMMISSION: 4,
  SORT_FIELD_GMV: 5,
  SORT_FIELD_STOCK: 6,
  SORT_FIELD_CREATE_TIME: 7
};
export var CreatorReviewStatus = {
  CREATOR_REVIEW_STATUS_UNSPECIFIED: 0,
  PRODUCT_ALL_ADDED: 1,
  PRODUCT_Partial_ADDED: 2,
  PRODUCT_NOT_ADDED: 3,
  PLAN_DELETE: 4,
  CREATOR_UNBIND: 5
};
export var AddProductScenario = {
  SHOW_CASE: 1,
  LIVE_ROOM: 2,
  PRE_LIVE: 3
};
export var CreatorReviewChangeStatus = {
  CHANGE_UNDER_REVIEW: 1,
  CHANGE_APPROVED: 2
};
export var CreatorReviewChangeType = {
  CHANGE_REMOVE_PLAN: 1,
  CHANGE_REMOVE_PRODUCT: 2
};
export var PlanSearchStatus = {
  SEARCH_STATUS_UNSPECIFIED: 0,
  SEARCH_STATUS_RUNNING: 1,
  SEARCH_STATUS_DELETING: 2,
  SEARCH_STATUS_DELETED: 3,
  SEARCH_STATUS_UNAVAILABLE: 4
};
export var ShopPlanStatus = {
  SHOP_PLAN_LIVE: 1,
  SHOP_PLAN_CLOSING: 2,
  SHOP_PLAN_COMMISSION_UPDATING: 3,
  SHOP_PLAN_DELETED: 4,
  SHOP_PLAN_UNAVAILABLE: 5
};
export var SearchType = {
  FUZZY: 1,
  EQUAL: 2,
  IN: 3,
  RANGE: 4
};
export var SortType = {
  DESC: 1,
  ASC: 2
};
export var OpenPlanStatus = {
  OPEN_PLAN__STATUS_UNSPECIFIED: 0,
  OPEN_PLAN_LIVE: 1,
  OPEN_PLAN_DELETING: 2,
  OPEN_PLAN_COMMISSION_UPDATING: 3,
  OPEN_PLAN_DELETED: 4
};
export var AffiliateProductStatus = {
  PRODUCT__STATUS_UNSPECIFIED: 0,
  PRODUCT_LIVE: 1,
  PRODUCT_PLATFORM_DE_ACTIVE: 2,
  PRODUCT_SELLER_DE_ACTIVE: 3,
  PRODUCT_FREEZE: 4,
  PRODUCT_DRAFT: 5,
  PRODUCT_OUT_OF_STOCK: 6,
  INCLUDE_IN_PLAN: 7,
  PRODUCT_PLATFORM_WITHDRAW: 8,
  PRODUCT_QC_FAILED: 9,
  PRODUCT_QC_PENDING: 10,
  PRODUCT_DELETED: 11,
  PRODUCT_REGION_UNAVAILABLE: 12,
  PRODUCT_PLATFORM_LIMIT: 13
};
export var OpenPlanSearchKey = {
  PRODUCT_NAME: 1,
  PRODUCT_ID: 2,
  PLAN_ID: 3,
  PRODUCT_FIRST_CATEGORY_ID: 4
};
export var OpenPlanSortKey = {
  PRICE: 1
};
export var OpenPlanProductSearchKey = {
  OPEN_PLAN_SELECTION_PRODUCT_NAME: 1,
  OPEN_PLAN_SELECTION_PRODUCT_ID: 2,
  OPEN_PLAN_SELECTION_PRODUCT_FIRST_CATEGORY_ID: 3
};
export var TargetPlanMetaType = {
  TARGET_PLAN_META_TYPE_UNSPECIFIED: 0,
  TARGET_PLAN_META_TYPE_PRODUCT_ID: 1
};
export var PlanSourceFrom = {
  UNSPECIFIED: 0,
  CREATOR_MARKET_PLACE: 1,
  OPEN_PLATFORM: 2,
  PRODUCT_CENTER: 3,
  PRODUCT_CENTER_GUIDE: 4,
  GUIDE_NEW_SELLER: 5,
  OPERATION_PLATFORM: 6,
  CAMPAIGN_PLATFROM: 7,
  PRODUCT_CENTER_OPPORTUNITY_BANNER: 8,
  SOURCE_SELLER_CENTER_START_TASK: 9
};
export var PromoteSourceFrom = {
  PROMOTE_SOURCE_UNSPECIFIED: 0,
  PROMOTE_SOURCE_CREATOR_MARKET_PLACE: 1,
  PROMOTE_SOURCE_OPEN_PLATFORM: 2,
  PROMOTE_SOURCE_PRODUCT_CENTER: 3,
  PROMOTE_SOURCE_PRODUCT_CENTER_GUIDE: 4,
  PROMOTE_SOURCE_GUIDE_NEW_SELLER: 5,
  PROMOTE_SOURCE_OPERATION_PLATFORM: 6,
  PROMOTE_SOURCE_CAMPAIGN_PLATFROM: 7,
  PROMOTE_SOURCE_PRODUCT_CENTER_OPPORTUNITY_BANNER: 8,
  PROMOTE_SOURCE_SELLER_CENTER_START_TASK: 9
};
export var ProductCategoryLevel = {
  FIRST_LEVEL: 1,
  SECOND_LEVEL: 2,
  THIRD_LEVEL: 3
};
export var OpportunityType = {
  UNKNOWN: 0,
  RECOMMENDED: 1,
  CAMPAIGN_TRENDING_BFCM: 2,
  DEMAND: 3,
  MOST_PICKED: 4,
  TOP_SEARCHED: 5,
  BEST_SELLER: 6,
  FAST_GROWING: 7
};
export var Source = {
  OPEN: 1,
  TARGET_INVITATION: 2
};
export var ProductSearchKey = {
  SELECTION_PRODUCT_NAME: 1,
  SELECTION_PRODUCT_ID: 2,
  SELECTION_PRODUCT_FIRST_CATEGORY_ID: 3,
  SELECTION_PRODUCT_IS_PROMOTED: 4,
  SELECTION_PRODUCT_IS_GROI_ELIGIBILITY: 5,
  SELECTION_PRODUCT_IS_GROI_ENROLLED: 6,
  SELECTION_PRODUCT_IS_SELLER_OPEN_THRESHOLD_SAMPLE: 7,
  SELECTION_PRODUCT_IS_REFUNDABLE_SAMPLE: 8,
  SELECTION_PRODUCT_IS_NOT_CREATED_SAMPLE: 9,
  SELECTION_PRODUCT_STATUS: 10,
  SELECTION_SAMPLE_SKU_SCOPE: 11
};
export var ProductSortField = {
  SORT_UNSPECIFIED: 0,
  SORT_PRICE: 1,
  SORT_SALES: 2,
  SORT_STOCK: 3
};
export var BaseProductStatus = {
  STATUS_UNSPECIFIED: 0,
  STATUS_LIVE: 1,
  STATUS_OUT_OF_STOCK: 2,
  STATUS_SELLER_DEACTIVATE: 3,
  STATUS_PLATFORM_DEACTIVATE: 4,
  STATUS_GNE_REJECT: 5,
  STATUS_DELETE: 6,
  STATUS_SOLD_ONLY_IN_TOKO: 7
};
export var ApplicationSearchScene = {
  APPLICATION_SEARCH_SCENE_ALL: 1,
  APPLICATION_SEARCH_SCENE_NEW: 2,
  APPLICATION_SEARCH_SCENE_APPROVED: 3
};
export var ApplicationSearchKey = {
  APPLICATION_SEARCH_KEY_CREATOR_ID: 1,
  APPLICATION_SEARCH_KEY_PRODUCT_ID: 2,
  APPLICATION_SEARCH_KEY_PRODUCT_NAME: 3
};
export var ApplicationFilterKey = {
  CREATOR_FOLLOWER_COUNT: 5,
  CREATOR_AGENCY: 10,
  CREATOR_MAIN_CATEGORY: 11,
  CREATOR_FOLLOWER_GENDER: 12,
  CREATOR_FOLLOWER_AGE: 13,
  CREATOR_CONTENT_TYPE: 14,
  CREATOR_COOPERATED_WITH_BEFORE: 15,
  CREATOR_GMV_RANGE: 17,
  CREATOR_AVG_VIDEO_VIEWS: 19,
  CREATOR_AVG_LIVE_VIEWS: 20
};
export var ApplicationFilterType = {
  Application_Filter_Type_KEYWORD: 1,
  Application_Filter_Type_WILDCARD: 2,
  Application_Filter_Type_RANGE: 3,
  Application_Filter_Type_IN: 4,
  Application_Filter_Type_BOOL: 5,
  Application_Filter_Type_SCENE: 6
};
export var Gender = {
  GENDER_ALL: 0,
  MALE: 1,
  FEMALE: 2
};
export var ApplicationStatus = {
  APPLICATION_STATUS_PENDING: 0,
  APPLICATION_STATUS_APPROVED: 1,
  APPLICATION_STATUS_REJECTED: 2,
  APPLICATION_STATUS_EXPIRED: 3,
  APPLICATION_STATUS_REJECTING: 4
};
export var ReviewAction = {
  REVIEW_ACTION_APPROVE: 1,
  REVIEW_ACTION_REJECT: 2
};
export var CommissionSuggestType = {
  SUGGEST_SINGLE_PRODUCT: 1,
  SUGGEST_MULTI_PRODUCT: 2,
  SUGGEST_SHOP: 3
};
export var AllowlistStatus = {
  ALLOWLIST_STATUS_ADD: 0,
  ALLOWLIST_STATUS_REMOVE: 1
};
export var SearchStatus = {
  PRODUCT_STATUS_OFF: 0,
  PRODUCT_STATUS_ON: 1,
  PRODUCT_STATUS_ALL: 2
};
export var PlanDeliveryType = {
  PLAN_LIVE: 1,
  PLAN_VIDEO: 2
};
export var CheckFailReason = {
  CHECK_CREATOR_NOTFOUND: 0,
  CHECK_CREATOR_NOCOMMERCE: 1,
  CHECK_CREATOR_ADDED: 2,
  CHECK_CREATOR_NOTREGION: 3,
  CHECK_CREATOR_OFFICIAL: 4
};
export var CheckLandingTaskPlanType = {
  TASK_PLAN_ALL: 1,
  TASK_PLAN_PUBLIC: 2
};
export var SellerLandingTaskExtraKeyType = {
  SELLER_LANDING_PAGE_FIRST_SHOW: 1,
  SELLER_FINISH_FIRST_LANDING_TASK: 2,
  SELLER_FINISH_SECOND_LANDING_TASK: 3
};